import React from 'react';

import ColourPicker from '../ColourPicker';

type ColourPickerFormGroupProps = {
    label?: string;
    value: string;
    onChange(hex: string): void;
};

const ColourPickerFormGroup: React.FC<ColourPickerFormGroupProps> = ({ label = 'Colour', value, onChange }) => (
    <>
        <div style={{ gridColumn: '1/auto' }}>
            <strong>{label}:</strong>
        </div>
        <div style={{ gridColumn: '2/6' }}>
            <ColourPicker onChange={({ hex }) => onChange(hex)} color={value} />
        </div>
    </>
);

export default React.memo(ColourPickerFormGroup);
